import { render, staticRenderFns } from "./techOrderDetails.vue?vue&type=template&id=2cd6d4ad&"
import script from "./techOrderDetails.vue?vue&type=script&lang=js&"
export * from "./techOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports